// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import VisibleSvg from '../icons/status/Visible';
var Visible = createSvgIcon({
    as: VisibleSvg,
    ariaLabel: 'visible',
    category: 'status',
    displayName: 'Visible'
});
export default Visible;
